import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaBoxOpen,
  FaShoppingCart,
  FaClipboardList,
  FaUserShield,
  FaTruck,
  FaHeadset,
  FaInfoCircle,
  FaSignInAlt,
  FaUserPlus
} from "react-icons/fa";
import "./Navbar.css";
import logo from "./navbarlogoimage/navbarlogo.png";

const Navbar = ({ user, setUser }) => {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/login");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light navbar-premium py-3">
      <div className="container-fluid">

        {/* BRAND */}
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <img src={logo} alt="Logo" className="brand-logo" />
          <span className="brand-text">
            <span className="brand-fruits">MJ Fruits </span>
            <span className="brand-export"> Packaging Materials</span>
          </span>
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#nav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* LINKS */}
        <div className="collapse navbar-collapse" id="nav">
          <ul className="navbar-nav me-auto">

            <li className="nav-item">
              <Link className="nav-link" to="/">
                <FaHome /> Home
              </Link>
            </li>

            {/* PRODUCTS */}
            <li className="nav-item dropdown">
              <Link className="nav-link dropdown-toggle" to="#" data-bs-toggle="dropdown">
                <FaBoxOpen /> Products
              </Link>

              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/products">All</Link></li>
                <li><Link className="dropdown-item" to="/products/apple">Apple</Link></li>
                <li><Link className="dropdown-item" to="/products/mango">Mango</Link></li>
                <li><Link className="dropdown-item" to="/products/orange">Orange</Link></li>
                <li><Link className="dropdown-item" to="/products/grapes">Grapes</Link></li>
                <li><Link className="dropdown-item" to="/products/pomegranate">Pomegranate</Link></li>
                <li><Link className="dropdown-item" to="/products/strawberry">Strawberry</Link></li>
              </ul>
            </li>

            {/* 🔐 ONLY LOGGED IN USERS */}
            {user && (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/cart">
                    <FaShoppingCart /> Cart
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/my-orders">
                    <FaClipboardList /> Orders
                  </Link>
                </li>
              </>
            )}

            {/* ROLE BASED */}
            {user?.role === "exporter" && (
              <li className="nav-item">
                <Link className="nav-link" to="/exporter-dashboard">
                  <FaTruck /> Exporter
                </Link>
              </li>
            )}

            {user?.role === "admin" && (
              <li className="nav-item">
                <Link className="nav-link" to="/admin-dashboard">
                  <FaUserShield /> Admin
                </Link>
              </li>
            )}

            <li className="nav-item">
              <Link className="nav-link" to="/support">
                <FaHeadset /> Support
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about">
                <FaInfoCircle /> About
              </Link>
            </li>

          </ul>

          {/* RIGHT SIDE */}
          <div className="d-flex align-items-center gap-3">

            {/* 👤 Logged In */}
            {user ? (
              <>
                <span className="nav-user">Hi, {user.name}</span>

                <button onClick={logout} className="btn btn-logout">
                  Logout
                </button>
              </>
            ) : (
              <>
                {/* 🔓 Guest */}
                <Link to="/login" className="btn btn-login">
                  <FaSignInAlt /> Login
                </Link>

                <Link to="/signup" className="btn btn-signup">
                  <FaUserPlus /> Signup
                </Link>
              </>
            )}

          </div>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;